"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthenticated = exports.AuthProvider = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var APIBase_1 = require("./APIBase");
var AuthContext = react_1.createContext({
    authenticated: false,
    setAuthenticated: function (tf) {
        console.error('auth context not configured');
    },
});
function AuthProvider(props) {
    var _a = react_1.useState(true), authenticated = _a[0], setAuthenticated = _a[1];
    var ctx = react_1.useMemo(function () { return ({ authenticated: authenticated, setAuthenticated: setAuthenticated }); }, [authenticated, setAuthenticated]);
    react_1.useEffect(function () {
        var sub = APIBase_1.notAuthorizedResponse.subscribe(function () {
            setAuthenticated(false);
        });
        return function () { return sub.cancel(); };
    }, []);
    return React.createElement(AuthContext.Provider, { value: ctx }, props.children);
}
exports.AuthProvider = AuthProvider;
function useAuthenticated() {
    return react_1.useContext(AuthContext);
}
exports.useAuthenticated = useAuthenticated;
